import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-migrated',
  templateUrl: './not-migrated.component.html',
  styleUrls: ['./not-migrated.component.scss']
})
export class NotMigratedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
